import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

export const BillStatsCards = ({ stats = {} }) => {
    // Default values for stats
    const defaultStats = {
        total: 0,
        paid: 0,
        pending: 0,
        overdue: 0
    };

    // Merge provided stats with default values
    const safeStats = { ...defaultStats, ...stats };

    return (
        <Row className="g-3 mb-4">
            <Col md={3}>
                <Card className="card-one">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6 className="card-title">Total Bills</h6>
                            <i className="ri-money-dollar-circle-line fs-24 text-primary"></i>
                        </div>
                        <h2 className="card-value mb-1">${(safeStats.total || 0).toFixed(2)}</h2>
                        <small className="d-block fs-sm">
                            Total amount of all bills
                        </small>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={3}>
                <Card className="card-one">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6 className="card-title">Paid Bills</h6>
                            <i className="ri-checkbox-circle-line fs-24 text-success"></i>
                        </div>
                        <h2 className="card-value mb-1">${(safeStats.paid || 0).toFixed(2)}</h2>
                        <small className="d-block fs-sm">
                            Total amount paid
                        </small>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={3}>
                <Card className="card-one">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6 className="card-title">Pending Bills</h6>
                            <i className="ri-time-line fs-24 text-warning"></i>
                        </div>
                        <h2 className="card-value mb-1">${(safeStats.pending || 0).toFixed(2)}</h2>
                        <small className="d-block fs-sm">
                            Amount pending payment
                        </small>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={3}>
                <Card className="card-one">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6 className="card-title">Overdue Bills</h6>
                            <i className="ri-error-warning-line fs-24 text-danger"></i>
                        </div>
                        <h2 className="card-value mb-1">${(safeStats.overdue || 0).toFixed(2)}</h2>
                        <small className="d-block fs-sm">
                            Amount past due date
                        </small>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}; 